module.exports = __webpack_public_path__ + "img/house-g27ea871c5_1920.fde8e730.jpg";